import type { RegistrationProductEntryRequirementsPlugin } from '@adornis/buchungsheld-db/db-plugins.js';
import { ProductEntryRequirementForParticipation } from '@adornis/buchungsheld-db/entities/ProductEntryRequirementForParticipation.js';

export const defaultRegistrationProductEntryRequirementsPlugin: RegistrationProductEntryRequirementsPlugin = {
  id: 'registration::product-entry-requirements::default',
  type: 'registration::product-entry-requirements',
  getRequirementKinds() {
    return [ProductEntryRequirementForParticipation];
  },
};
